import { render, staticRenderFns } from "./videoTool.vue?vue&type=template&id=febccc34&scoped=true"
import script from "./videoTool.vue?vue&type=script&lang=js"
export * from "./videoTool.vue?vue&type=script&lang=js"
import style0 from "./videoTool.vue?vue&type=style&index=0&id=febccc34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febccc34",
  null
  
)

export default component.exports